export const PUZZLE_FULL_GUIDE_RESOLVED_SHOTS = 3;
export const PUZZLE_SHORT_GUIDE_ROWS = 3;

export interface PuzzleGuidePolicy {
  limited: boolean;
  maxSteps: number | null;
}

/**
 * The first three resolved shots retain the full teaching trajectory. From the
 * fourth shot onward, only about three logical bubble rows are revealed.
 */
export function puzzleGuidePolicy(
  shotsResolved: number,
  hexRowHeight: number,
  stepDistance: number
): PuzzleGuidePolicy {
  const limited = Number.isFinite(shotsResolved)
    && Math.max(0, Math.floor(shotsResolved)) >= PUZZLE_FULL_GUIDE_RESOLVED_SHOTS;
  if (!limited) return { limited: false, maxSteps: null };

  const safeRowHeight = Number.isFinite(hexRowHeight) ? Math.max(1, hexRowHeight) : 1;
  const safeStepDistance = Number.isFinite(stepDistance) ? Math.max(1, stepDistance) : 1;
  return {
    limited: true,
    maxSteps: Math.max(1, Math.round((safeRowHeight * PUZZLE_SHORT_GUIDE_ROWS) / safeStepDistance))
  };
}
